import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// Be careful the different files in the "local" folder need to have the same structure ! (ex: fr.json = en.json)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  // to change depending if we prefer fr (fr.json) or en (en.json). Need to uncomment 2 lines below for production/dev
  locale: process.env.VUE_APP_I18N_LOCALE || 'fr',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fr',
  // locale: 'fr',
  // fallbackLocale: 'fr',
  messages: loadLocaleMessages()
})
